import reducer from './reducers';

export { default as industryActions } from './actions';
export { default as industrySagas } from './sagas';
export { defaultIndustryRoleSelector, industryRolesSelector } from './selectors';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/industry/index.js